import { host } from '../config';

export default function getReport(data, stateTown) {
    return fetch(`${host}/estatutos/reportes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(data => {
            let downloadLink = document.createElement("a");
            downloadLink.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ data.file ;;
            downloadLink.download = `NOM-005_${ stateTown }.xlsx`;
            downloadLink.click();
        }).catch(ex => { console.log('ERROR', ex); return [] })
}
